import { render } from "./Category.vue?vue&type=template&id=6a2000a0&scoped=true"
import script from "./Category.vue?vue&type=script&lang=js"
export * from "./Category.vue?vue&type=script&lang=js"

import "./Category.vue?vue&type=style&index=0&id=6a2000a0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a2000a0"]])

export default __exports__